module.exports = __webpack_public_path__ + "img/goal-seven-en.73ac8800.png";